import { useState } from 'react'

import classes from './TextareaBox.module.css'

export default function FormTextareaBox({
    label,
    name,
    id,
    value,
    onChange,
    required = false,
    placeholder = '',
    height = 'medium',
    helperText,
    errorText,
}) {
    const fieldId = id || name
    const [isFocused, setIsFocused] = useState(false)
    const isActive = isFocused || Boolean(value)

    const clearHandler = () => {
        onChange?.({ target: { value: '' } })
        setIsFocused(false)
    }

    return (
        <div>
            <div className={`${classes.textarea_box} ${height ? classes[`height_${height}`] : ''}`}>
                <div className={`${classes.textarea_box_fields} ${isActive ? classes.focused : ''}`}>
                    {label && (
                        <label htmlFor={fieldId} className={classes.label}>
                            {label}
                            {required ? <span className="required">*</span> : null}
                        </label>
                    )}
                    <textarea
                        className={classes.textarea}
                        name={name}
                        id={fieldId}
                        value={value}
                        onChange={onChange}
                        onFocus={() => setIsFocused(true)}
                        onBlur={(e) => {
                            if (!e.target.value) {
                                setIsFocused(false)
                            }
                        }}
                        required={required}
                        placeholder={placeholder}
                    />
                    {value && (
                        <button className={classes.clear_input} type="button" onClick={clearHandler}>
                            <i className="ti ti-x" />
                            <span className="sr-only">clear input</span>
                        </button>
                    )}
                </div>
            </div>
            {helperText && (
                <div className="m-top-4" style={{ fontSize: "12px", color: "var(--subtitle)", lineHeight: 1.4 }}>
                    {helperText}
                </div>
            )}
            {errorText && (
                <div className="m-top-4 primary_color" style={{ fontSize: "12px", lineHeight: 1.4 }}>
                    {errorText}
                </div>
            )}
        </div>
    )
}
